import React from 'react';

type BadgeVariant = 'active' | 'on-loan' | 'for-sale' | 'archived' | 'electric' | 'acoustic' | 'bass' | 'classical' | 'neutral' | 'warning' | 'danger' | 'success';

const variantStyles: Record<BadgeVariant, string> = {
  active: 'bg-positive/10 text-positive border-positive/20',
  'on-loan': 'bg-info/10 text-info border-info/20',
  'for-sale': 'bg-warning/10 text-warning border-warning/20',
  archived: 'bg-muted text-muted-foreground border-border',
  electric: 'bg-primary/10 text-primary border-primary/20',
  acoustic: 'bg-amber-50 text-amber-700 border-amber-200',
  bass: 'bg-purple-50 text-purple-700 border-purple-200',
  classical: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  neutral: 'bg-muted text-muted-foreground border-border',
  warning: 'bg-warning/10 text-warning border-warning/20',
  danger: 'bg-negative/10 text-negative border-negative/20',
  success: 'bg-positive/10 text-positive border-positive/20',
};

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

export default function Badge({ variant = 'neutral', children, className = '' }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-600 border ${variantStyles[variant]} ${className}`}>
      {children}
    </span>
  );
}